"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("../../../../lexicons");
const util_1 = require("../../../../util");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestionsSkeleton';
function toKnownErr(e) {
    return e;
}
//# sourceMappingURL=getSuggestionsSkeleton.js.map